import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { find } from 'lodash';
import Markdown from 'react-markdown-el';
import ReactGA from 'react-ga';

import arrowLeft from './arrowLeft.svg';
import tweetButton from './tweetButton.svg';


class Tweet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: '',
      parsedText: '',
      focus: false
    };
  }

  componentWillMount() {

    if (this.props.reps.length === 0) {
      browserHistory.push(`/${this.props.params.appId}`);
      return;
    }

    if (this.props.reps) {
      let rep = find(this.props.reps, (rep) => rep.bioguide_id === this.props.params.id);
      let text = eval('`'+this.props.messages.tweet+'`');

      this.handleChange(text);
    }
  }

  handleChange = (text) => {

    var parsedText = text.replace(/[@]+[A-Za-z0-9-_]+/g, function(u) {
      return `**${u}**`;
    }).replace(/[#]+[A-Za-z0-9-_]+/g, function(t) {
      return `**${t}**`;
    });

    this.setState({ text, parsedText});
  }

  handleClick = () => {
    ReactGA.event({
      category: 'Bespoke Contact Congress',
      action: 'click',
      label: 'send tweet'
    });
  }

  handleBack = () => {
    ReactGA.event({
      category: 'Bespoke Contact Congress',
      action: 'click',
      label: 'previous'
    });

    browserHistory.goBack();
  }

  render() {
    const opacity = this.state.focus? '1' : '0';

    return (
      <div className="Tweet">
        <h2>Tweet at your Legislator</h2>
          <label className="zipLabel" htmlFor="zip">EDIT AS DESIRED:</label>
          <div className="wrapInput">
            <Markdown text={this.state.parsedText} />
            <textarea
              style={{opacity}}
              onBlur={() => this.setState({focus: false})}
              onFocus={() => this.setState({focus: true})}
              onChange={(e) => this.handleChange(e.target.value)}
              value={this.state.text}
            ></textarea>
          </div>
          <a className="tweetButton" target="_blank" onClick={this.handleClick} href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(this.state.text)}`}><img src={tweetButton} /></a>
          <a className="previousButton" onClick={this.handleBack}><img className="previousArrow" src={arrowLeft} />Previous</a>
      </div>
    );
  }
};

export default Tweet;





// WEBPACK FOOTER //
// ./src/Tweet.js